/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import {
    string, node, object, bool, func, oneOf,
    number,
} from 'prop-types';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core';
import { trackEvent } from '../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const useStyles = makeStyles((theme) => ({
    disableClick: {
        cursor: 'inherit !important',
    },
}));

const LinkOrATag = ({
    href,
    id,
    children,
    style,
    name,
    className,
    indexKey,
    dataTest,
    trackingEventAction,
    trackingEventCategory,
    trackingEventLabel,
    isTrackEventEnabled,
    title,
    ariaLabel,
    handleCallback,
    doNotSell,
    noLinkOrTitle,
    handleMouseHover,
    keyValue,
    openInNewTab,
    isPersonalized,
    trackClickThrough,
}) => {
    const classes =  useStyles();
    const dispatch = useDispatch();
    const isExternalLink = href?.includes('/blog') || href?.includes('www') || href?.indexOf('http://') === 0 || href?.indexOf('https://') === 0 || href?.includes(('/articles')) || href?.includes(('/local'));
    const handleTrackEvent = (e) => {
        e.stopPropagation();
        if (isTrackEventEnabled && trackingEventLabel) {
            const category = isExternalLink ? 'external-link' : 'internal-link';
            const action = isExternalLink ? href : `https://www.1800flowers.com${href}`;
            dispatch(trackEvent({
                eventCategory: trackingEventCategory || category,
                eventAction: trackingEventAction || action,
                eventLabel: trackingEventLabel || '',
                link_text: typeof children === 'string' ? children : title || href,
                link_url: href || '',
            }));
        }
        if (typeof handleCallback === 'function' && !isPersonalized) {
            handleCallback(e, title);
        }
        if (typeof doNotSell === 'function') {
            doNotSell(href);
        }
        if (isPersonalized) {
            trackClickThrough();
        }
    };
    if (noLinkOrTitle) {
        return <div className={`${className} ${classes.disableClick}`}>{children}</div>;
    }
    if (isExternalLink) {
        return (
            <a
                target={openInNewTab ? '_blank' : '_self'}
                rel={openInNewTab ? 'noreferrer' : ''}
                style={style}
                aria-label={ariaLabel}
                className={className}
                id={id}
                href={href}
                name={name}
                key={indexKey}
                data-test={dataTest}
                data-testid={dataTest}
                onClick={handleTrackEvent}
                title={title}
                data-ga-category={trackingEventCategory || ''}
                data-ga-action={trackingEventAction || ''}
                data-ga-label={trackingEventLabel || ''}
            >{children}
            </a>
        );
    }
    return (
        <Link
            target={openInNewTab ? '_blank' : '_self'}
            aria-label={ariaLabel}
            onMouseOver={() => handleMouseHover(keyValue, true)}
            onMouseLeave={() => handleMouseHover(keyValue, false)}
            style={style}
            to={href}
            id={id}
            className={className}
            name={name}
            key={indexKey}
            data-test={dataTest}
            data-testid={dataTest}
            onClick={handleTrackEvent}
            title={title}
            data-ga-category={trackingEventCategory || ''}
            data-ga-action={trackingEventAction || ''}
            data-ga-label={trackingEventLabel || ''}
        >{children}
        </Link>
    );
};

LinkOrATag.propTypes = {
    href: string.isRequired,
    id: string,
    children: node.isRequired,
    style: object,
    name: string,
    className: string,
    indexKey: string,
    dataTest: string,
    trackingEventLabel: string,
    isTrackEventEnabled: bool,
    title: string,
    trackingEventAction: string,
    trackingEventCategory: string,
    ariaLabel: string,
    handleCallback: func,
    doNotSell: oneOf([bool, func]),
    noLinkOrTitle: bool,
    handleMouseHover: func,
    keyValue: oneOf([string, number]),
    openInNewTab: bool,
    isPersonalized: bool,
    trackClickThrough: func,
};

LinkOrATag.defaultProps = {
    id: null,
    style: {},
    name: null,
    className: '',
    indexKey: '',
    dataTest: '',
    trackingEventAction: '',
    trackingEventLabel: '',
    trackingEventCategory: '',
    isTrackEventEnabled: false,
    title: '',
    ariaLabel: '',
    handleCallback: () => {},
    handleMouseHover: () => {},
    doNotSell: false,
    noLinkOrTitle: false,
    keyValue: '',
    openInNewTab: false,
    isPersonalized: false,
    trackClickThrough: () => { },
};

export default LinkOrATag;
